import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-43452065"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "edit-page-score"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "edit-page-score-box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "edit-page-score-text"
}, "Score"), /*#__PURE__*/_createElementVNode("div", {
  class: "edit-page-score-description"
}, "Listing score based on its compliance for best practices")], -1));
const _hoisted_3 = {
  class: "edit-page-score-modal-inner"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "modal-head-text"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "modal-head-text-title"
}, "Score"), /*#__PURE__*/_createElementVNode("div", {
  class: "modal-head-text-description"
}, "Listing score based on its compliance for best practices")], -1));
const _hoisted_5 = {
  class: "modal-content"
};
const _hoisted_6 = {
  class: "modal-content-item-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_circle_progress = _resolveComponent("app-circle-progress");
  const _component_app_icon = _resolveComponent("app-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(['edit-page-score-inner', {
      wide: $props.wide
    }]),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onModalToggle && $options.onModalToggle(...args))
  }, [_hoisted_2, _createVNode(_component_app_circle_progress, {
    class: "edit-page-score-progress",
    value: $options.successRules,
    maxValue: $options.allRules
  }, null, 8, ["value", "maxValue"])], 2), _createElementVNode("div", {
    class: _normalizeClass(['edit-page-score-modal', {
      open: this.isModalOpen
    }])
  }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: "modal-head",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.onModalToggle && $options.onModalToggle(...args))
  }, [_createVNode(_component_app_circle_progress, {
    value: $options.successRules,
    maxValue: $options.allRules,
    size: 40,
    stroke: 4,
    font: 14
  }, null, 8, ["value", "maxValue"]), _hoisted_4, _createVNode(_component_app_icon, {
    icon: "chevron-down2",
    size: 20,
    color: "#616161"
  })]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.validate, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "modal-content-item"
    }, [_createElementVNode("div", _hoisted_6, _toDisplayString(item.text), 1), _createVNode(_component_app_icon, {
      icon: `${item.status}-circle`
    }, null, 8, ["icon"])]);
  }), 128))])])], 2)]);
}